/**
 * Brace1 seller application — POST JSON to marketplace API.
 * Public config only: API base URL (no Supabase keys).
 */
(function () {
  if (window.__BRACE1_SELL__) return;
  window.__BRACE1_SELL__ = true;

  var root = document.querySelector("[data-brace1-sell]");
  if (!root) return;

  var form = root.querySelector("[data-seller-form]");
  var statusEl = root.querySelector("[data-seller-status]");
  var successEl = root.querySelector("[data-seller-success]");
  var formWrap = root.querySelector("[data-seller-form-wrap]");
  var applyBtns = root.querySelectorAll("[data-scroll-apply]");
  var submitBtn = form && form.querySelector('[type="submit"]');

  var apiBase =
    (window.BRACE1_MARKETPLACE_API_BASE ||
      root.getAttribute("data-marketplace-api-base") ||
      "")
      .trim()
      .replace(/\/$/, "");

  applyBtns.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var target = root.querySelector("#seller-apply");
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  function val(name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (!el) return "";
    if (el.type === "checkbox" && el.name.indexOf("product_feed_type") === -1) {
      return el.checked ? "yes" : "no";
    }
    return String(el.value || "").trim();
  }

  function checkedValues(name) {
    return Array.prototype.slice
      .call(form.querySelectorAll('[name="' + name + '"]:checked'))
      .map(function (el) {
        return el.value;
      });
  }

  function toIntOrEmpty(raw) {
    var s = String(raw || "").trim();
    if (!s) return undefined;
    var n = Number(s);
    if (!Number.isFinite(n)) return s;
    return Math.trunc(n);
  }

  function collectPayload() {
    return {
      legal_name: val("legal_name"),
      dba_name: val("dba_name"),
      website: val("website"),
      business_email: val("business_email"),
      phone: val("phone"),
      business_type: val("business_type"),
      state: val("state"),
      country: val("country"),
      years_in_business: toIntOrEmpty(val("years_in_business")),
      primary_contact_name: val("primary_contact_name"),
      job_title: val("job_title"),
      contact_email: val("contact_email") || val("business_email"),
      contact_phone: val("contact_phone"),
      dropshipping: val("dropshipping"),
      electronic_tracking: val("electronic_tracking"),
      map_pricing: val("map_pricing"),
      upc_mpn: val("upc_mpn"),
      aces_pies: val("aces_pies"),
      product_feed_type: checkedValues("product_feed_type"),
      sku_count: toIntOrEmpty(val("sku_count")),
      manufactures_products: val("manufactures_products"),
      brands_carried: val("brands_carried"),
      product_categories: val("product_categories"),
      ship_from_city: val("ship_from_city"),
      ship_from_state: val("ship_from_state"),
      ship_from_country: val("ship_from_country"),
      handling_days: toIntOrEmpty(val("handling_days")),
      return_address: val("return_address"),
      return_policy: val("return_policy"),
      has_fitment_data: val("has_fitment_data"),
      vehicle_fitment_notes: val("vehicle_fitment_notes"),
      ein_last4: val("ein_last4"),
      company_fax: val("company_fax"),
      source: "sell-on-brace1",
    };
  }

  function validateClient(payload) {
    var missing = [];
    if (!payload.legal_name) missing.push("Legal business name");
    if (!payload.business_email) missing.push("Business email");
    if (!payload.business_type) missing.push("Business type");
    if (!payload.country) missing.push("Country");
    if (!payload.primary_contact_name) missing.push("Primary contact name");
    if (!payload.contact_email) missing.push("Contact email");
    if (!payload.brands_carried) missing.push("Brands carried");
    if (!payload.product_feed_type.length) missing.push("Product data method");
    if (!payload.has_fitment_data) missing.push("Fitment data (YMM)");
    if (payload.ein_last4 && !/^\d{4}$/.test(payload.ein_last4)) {
      missing.push("EIN last 4 (exactly 4 digits)");
    }
    return missing;
  }

  function setStatus(kind, text) {
    if (!statusEl) return;
    statusEl.hidden = false;
    statusEl.className = "bs-status" + (kind ? " is-" + kind : "");
    statusEl.textContent = text;
  }

  function showSuccess(applicationId) {
    if (formWrap) formWrap.hidden = true;
    if (successEl) {
      successEl.hidden = false;
      var ref = successEl.querySelector("[data-application-id]");
      if (ref) ref.textContent = applicationId;
    }
    if (statusEl) statusEl.hidden = true;
  }

  function setSubmitting(on) {
    if (!submitBtn) return;
    submitBtn.disabled = !!on;
    submitBtn.textContent = on ? "Submitting…" : "Submit application";
  }

  /**
   * POST JSON to marketplace API. Returns Promise<{ok, application_id?, message?, error?}>.
   */
  function submitSellerApplication(payload) {
    if (!apiBase) {
      return Promise.resolve({
        ok: false,
        error: "config",
        message:
          "Marketplace API is not configured. Set the Sell on Brace1 section API base URL.",
      });
    }

    return fetch(apiBase + "/api/vendors/apply", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
      credentials: "omit",
    }).then(function (res) {
      return res.json().catch(function () {
        return {
          ok: false,
          error: "bad_response",
          message: "Unexpected response from server.",
        };
      }).then(function (json) {
        if (!res.ok) {
          return {
            ok: false,
            error: (json && json.error) || "request_failed",
            message:
              (json && json.message) ||
              "Unable to submit application. Please try again.",
            status: res.status,
          };
        }
        return json;
      });
    });
  }

  window.BRACE1_SELLER = {
    collectPayload: collectPayload,
    validate: validateClient,
    submitSellerApplication: submitSellerApplication,
    apiBase: apiBase,
  };

  if (!form) return;

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var payload = collectPayload();
    var missing = validateClient(payload);
    if (missing.length) {
      setStatus("error", "Please complete: " + missing.join(", ") + ".");
      return;
    }

    setSubmitting(true);
    setStatus("", "Submitting…");

    submitSellerApplication(payload)
      .then(function (result) {
        if (result && result.ok && result.application_id) {
          showSuccess(result.application_id);
          return;
        }
        setStatus(
          "error",
          (result && result.message) ||
            "Unable to submit application. Please try again."
        );
      })
      .catch(function () {
        setStatus(
          "error",
          "Network error. Check your connection and try again."
        );
      })
      .then(function () {
        setSubmitting(false);
      });
  });
})();
